import { mapState } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'CoreDtwinRuleEditTimeTriggers',
  props: {
    rule: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    // the states that are to be displayed / edited
    states: {
      type: Array,
      required: true
    }
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    requiredRule() {
      return [v => !!v || parseInt(v) === 0 || this.$i18n_t('Common.fieldRequired')];
    },
    hourRules() {
      return [...this.requiredRule, v => v >= 0 && v <= 23 || this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.hourRule')];
    },
    minuteRules() {
      return [...this.requiredRule, v => v >= 0 && v <= 59 || this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.minuteRule')];
    },
    timeTriggers() {
      return (get(this.rule, 'properties.timeTriggers') || []).filter(t => {
        return !!get(t, 'time') && t.time.constructor === Object;
      });
    },
    hourRuleEveryX() {
      return [...this.requiredRule, v => v > 0 || this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.hourRuleEveryX')];
    }
  },
  watch: {},
  methods: {
    startDatePicked(dateObject, i) {
      this.rule.properties.timeTriggers[i].dateStart = new Date(dateObject.from * 1000).toISOString();
      this.refreshTimeTriggers();
    },
    endDatePicked(dateObject, i) {
      this.rule.properties.timeTriggers[i].dateEnd = new Date(dateObject.from * 1000).toISOString();
      this.refreshTimeTriggers();
    },
    refreshTimeTriggers() {
      this.$emit('refresh-form');
    }
  }
};